module.exports = __webpack_public_path__ + "img/picon1.0885887f.png";